var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8234 7.77365L10.2792 16.3388L7.36 13.2913C7.28682 13.2166 7.19948 13.1572 7.10308 13.1167C7.00668 13.0762 6.90317 13.0554 6.79861 13.0554C6.69405 13.0554 6.59054 13.0762 6.49414 13.1167C6.39775 13.1572 6.3104 13.2166 6.23723 13.2913C6.16206 13.3658 6.10239 13.4545 6.06168 13.5523C6.02096 13.65 6 13.7548 6 13.8607C6 13.9665 6.02096 14.0714 6.06168 14.1691C6.10239 14.2668 6.16206 14.3555 6.23723 14.4301L9.70178 18.1192C9.77583 18.1975 9.86549 18.2593 9.96496 18.3008C10.0644 18.3422 10.1715 18.3623 10.2792 18.3598C10.3934 18.3507 10.5046 18.3192 10.6065 18.2668C10.7083 18.2145 10.7988 18.1425 10.8727 18.055L17.9782 8.75206C18.0928 8.5831 18.1386 8.37681 18.1063 8.17523C18.0741 7.97366 17.9662 7.79197 17.8046 7.66721C17.643 7.54245 17.4399 7.484 17.2367 7.50377C17.0336 7.52355 16.8456 7.62007 16.7111 7.77365H16.8234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTick);
export default __webpack_public_path__ + "static/media/gray-tick.a0a37478818066db7e1d8163e85d823a.svg";
export { ForwardRef as ReactComponent };